import { BookOpen, CheckCircle2, Lock } from "lucide-react";
import { cn } from "@/lib/utils";

interface LessonCardProps {
  title: string;
  description?: string;
  status: "locked" | "available" | "completed";
  onClick: () => void;
  lessonNumber: number;
}

const LessonCard = ({ title, description, status, onClick, lessonNumber }: LessonCardProps) => {
  return (
    <button
      onClick={status !== "locked" ? onClick : undefined}
      disabled={status === "locked"}
      className={cn(
        "w-full p-5 rounded-2xl border text-left transition-all duration-200 flex items-center gap-4",
        status === "locked" && "bg-muted/50 border-border opacity-60 cursor-not-allowed",
        status === "available" && "glass-card glow-border hover:shadow-card-hover cursor-pointer",
        status === "completed" && "bg-emerald-500/8 border-emerald-500/20 cursor-pointer hover:border-emerald-500/30 transition-colors"
      )}
    >
      <div className={cn(
        "w-10 h-10 rounded-xl flex items-center justify-center shrink-0",
        status === "locked" && "bg-muted",
        status === "available" && "bg-primary/10",
        status === "completed" && "bg-emerald-500/12"
      )}>
        {status === "locked" && <Lock className="w-5 h-5 text-muted-foreground" />}
        {status === "available" && <BookOpen className="w-5 h-5 text-primary" />}
        {status === "completed" && <CheckCircle2 className="w-5 h-5 text-emerald-400" />}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-heading font-semibold text-foreground text-sm">Lesson {lessonNumber}: {title}</p>
        {description && <p className="text-xs text-muted-foreground mt-0.5 truncate">{description}</p>}
      </div>
      {status === "completed" && <span className="text-xs font-medium text-emerald-400">Complete</span>}
    </button>
  );
};

export default LessonCard;
